import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"faucet-page"},[_c(VCard,{staticStyle:{"display":"inline-block","max-width":"600px"},attrs:{"color":"rgba(0.5, 0.5, 0.5, 0.6)"}},[_c(VCardTitle,[_vm._v(" GLMR Faucet ")]),_c(VCardText,{staticClass:"text-left"},[_vm._v(" This faucet is currently not active. "),_c('br'),_vm._v(" Stay tuned for updates. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }